import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './components/Home'; // Import your Home component
import ProductList from './components/ProductList'; // Import your ProductSinglePage component
import ProductSinglePage from './components/ProductSingle'; // Import your ProductSinglePage component
import BrandSinglePage from './components/Brand'; // Import your ProductSinglePage component
import BrandListPage from './components/BrandList'; // Import your ProductSinglePage component
import ModelSinglePage from './components/Model'; // Import your ProductSinglePage component
import Look from './components/Look'; // Import your ProductSinglePage component
import RecommendationsPage from './components/Recommendations'; // Import your ProductSinglePage component
import Profile from "./components/user/Profile"; // Import your ProductSinglePage component
import Cart from "./components/Cart"; // Import your ProductSinglePage component
import Auth from "./components/Auth"; // Import your ProductSinglePage component
import Orders from "./components/user/Orders"; // Import your ProductSinglePage component
import ProfileData from "./components/user/ProfileData";
import OrderAddressSelect from "./components/order/OrderAddressSelect"; // Import your ProductSinglePage component
import OrderTime from "./components/order/OrderTime"; // Import your ProductSinglePage component
import LandingPage from "./components/landing/LandingPage"; // Import your ProductSinglePage component
import PrivacyPolicy from "./components/PrivacyPolicy";
import NotFound from "./components/NotFound";
import OrderPayment from "./components/order/OrderPayment"; // Import your ProductSinglePage component
import AddressList from "./components/user/AddressList"; // Import your ProductSinglePage component
import AddressSingle from "./components/user/AddressSingle";
import OrderAddressAdd from "./components/order/OrderAddressAdd";
import OrderUser from "./components/order/OrderUser";
import CardList from "./components/user/CardList"; // Import your ProductSinglePage component
import Saved from './components/Saved';
import OrderSingle from './components/user/OrderSingle';
import RefundPage from './components/user/RefundPage';
import Refunds from './components/user/Refunds';
import StylistList from './components/StylistList';
import StylistSinglePage from './components/Stylist';
import OrderContract from "./components/OrderContract";
import ProductListWrapper from "./components/ProductListWrapper";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />

                <Route path="/product/*" element={<ProductListWrapper />} />

                <Route path="/brands" element={<BrandListPage />} />
                <Route path="/brand/:brandId" element={<BrandSinglePage />} />
                <Route path="/order/:orderId" element={<OrderSingle />} />
                <Route path="/refunds" element={<Refunds />} />
                <Route path="/refund/:orderId" element={<RefundPage />} />
                <Route path="/recommendations" element={<RecommendationsPage />} />
                <Route path="/look/:lookId" element={<Look />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/saved" element={<Saved />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/profile-data" element={<ProfileData />} />
                <Route path="/address-list" element={<AddressList />} />
                <Route path="/address-new" element={<AddressSingle />} />
                <Route path="/address-single/:addressId" element={<AddressSingle />} />
                <Route path="/order-address-select" element={<OrderAddressSelect />} />
                <Route path="/order-address-add" element={<OrderAddressAdd />} />
                <Route path="/order-time" element={<OrderTime />} />
                <Route path="/order-user" element={<OrderUser />} />
                <Route path="/order-payment" element={<OrderPayment />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/cards" element={<CardList />} />
                <Route path="/landing/:brandName" element={<LandingPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/order-contract" element={<OrderContract />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default App;
